import Globals from "../Globals.js";
import PageCommon from "./PageCommon.js";

export default class PageDefault extends PageCommon {
    constructor() {
        super();
    }
    init() {
        super.init();
        this.showPreloader(true);
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("PageDefault - Hello world");
    }
}
